var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"side"},[_c('router-link',{staticClass:"side-content button",class:{ active: _vm.isActivePage(['nolaNovel']) },attrs:{"to":"/nolanovel"}},[_vm._v(" "+_vm._s(_vm.$t("nolaNovelSideMenu.postedWorks"))+" ")]),_c('CarouselBanner',{staticClass:"carousel-banner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }